<template>
  <a
    v-if="hirId"
    :href="cikkSzerkesztoLink"
    class="hirszerkeszto-link"
    target="_blank"
  >
    <span v-if="aktualisProjekt"> {{ aktualisProjekt.Nev }} - </span>
    Streamnext&trade; 2022
  </a>
</template>

<script>
import { mapGetters } from 'vuex';
import settings from '../../settings';
import { AppStoreTypes } from '../../store/modules/app';
export default {
  name: 'cikk-admin-link',
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    cikkSzerkesztoLink() {
      return `${settings.adminUrl}#/article/${this.hirId}`;
    },
    aktualisProjekt() {
      return this.user?.Projekt;
    },
  },
  props: {
    hirId: {},
  },
};
</script>
